export default "__VITE_ASSET__uiln2YRO__"